import { render, staticRenderFns } from "./GoodsCountDiscount.vue?vue&type=template&id=767487d4"
import script from "./GoodsCountDiscount.vue?vue&type=script&lang=js"
export * from "./GoodsCountDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports